import type React from 'react';
import type { HTMLAttributes } from 'react';

interface Props extends HTMLAttributes<HTMLFormElement> {
  children: React.ReactNode;
}

export default function ({ children, ...props }: Props) {
  return <form {...props}>{children}</form>;
}
